import {SubmissionId} from '@/types/Submission';

export enum SearchOrder {
    New = 'new',
    Favorites = 'favorites',
}

export default interface SearchFilter {
    order: SearchOrder;
    submissionId?: SubmissionId;
    partialName?: string;
    genre?: string;
    onlyFavoritesUid?: UID;
}
